import { render } from "./BlogEcoFriendlyGiftsView.vue?vue&type=template&id=3041894e"
import script from "./BlogEcoFriendlyGiftsView.vue?vue&type=script&lang=js"
export * from "./BlogEcoFriendlyGiftsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__